// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === "Page/Page") return "" + chunkId + "-540c6b7c8618e8d97922.css";
	// return url for filenames based on template
	return "" + chunkId + "-" + "407f76b40a6114035848" + ".css";
};